export default __webpack_public_path__ + "static/media/centro_andes_2_8.0a93b3a7.JPG";